import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteExportMutation } from "modules/FactoryExportsDashboard/components/DeleteExportModal/hooks";

import type { FactoryExport } from "models";

type DeleteExportModalProps = {
  factoryExport: FactoryExport | null;
  onClose: () => void;
};

export const DeleteExportModal = ({ factoryExport, onClose }: DeleteExportModalProps) => {
  const { t } = useTranslation();

  const { mutate: deleteExport, isPending } = useDeleteExportMutation();
  if (factoryExport === null) return;

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={true}
      isLoading={isPending}
      handleCancel={onClose}
      handleConfirm={() => deleteExport({ factory_export_id: factoryExport.id }, { onSuccess: () => onClose() })}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
    />
  );
};
